<nav-bar titulo="Elenco +" [iconeNotificacoes]="false" [botaoMenu]="true"
    (logoutEvent)="logout($event)"></nav-bar>
<menu-lateral [itensMenu]="menuItens"></menu-lateral>
